/* eslint-disable react/prop-types */

import React, { useRef, useEffect } from 'react';
import Flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css'; // Local Flatpickr styles
import { Col, Row } from 'react-bootstrap';
import { format } from 'date-fns';
import { FormLabel } from 'screens/common/dynamicForm/dynamicNormalForm/FormFields/FormLabel';
import { MdOutlineRefresh } from 'react-icons/md';

const MonthDayRange = ({ onRangeChange, noLabel, styleWidth, metadata }) => {
  const datePickerRef = useRef(null);
  const flatpickrInstance = useRef(null); // Store the Flatpickr instance

  const parseDate = dateStr => {
    if (!dateStr) return null;
    const [, month, day] = dateStr.split('-'); // Extract MM and DD ignoring YYYY
    return new Date(2000, parseInt(month, 10) - 1, parseInt(day, 10)); // Use a fixed year (2000)
  };

  const startDate = parseDate(metadata?.defaultValue?.start_date);
  const endDate = parseDate(metadata?.defaultValue?.end_date);
  const defaultPlaceholder = `${format(new Date(10, 1), 'MMM dd')} to ${format(
    new Date(),
    'MMM dd'
  )}`;
  useEffect(() => {
    if (datePickerRef.current) {
      flatpickrInstance.current = Flatpickr(datePickerRef.current, {
        mode: 'range',
        dateFormat: 'd/m', // Internal format for API or backend
        altInput: true, // Use an alternate input for display
        altFormat: 'M d', // Custom format: "Feb 01"
        disableMobile: true, // Disable mobile date picker
        defaultDate: startDate && endDate ? [startDate, endDate] : [],
        onOpen: (selectedDates, dateStr, instance) => {
          const yearSelectors = instance.calendarContainer.querySelectorAll(
            '.numInputWrapper, .flatpickr-current-month input'
          );
          yearSelectors.forEach(el => (el.style.display = 'none')); // Hides Year input
        },
        onChange: selectedDates => {
          // Extract the start and end dates from the selected range
          const [start, end] = selectedDates;
          // Pass them to the parent component using the callback
          onRangeChange(start, end);
        }
      });
    }
  }, []);

  return (
    <div className="form-group">
      {noLabel ? null : (
        <FormLabel
          label={metadata?.label}
          required={metadata?.validation?.required}
        />
      )}
      <Row className="d-flex align-items-center pb-2">
        <Col
          {...(!styleWidth ? { md: 4 } : {})}
          className="d-flex align-items-center justify-content-start pr-0"
        >
          <input
            ref={datePickerRef}
            id="rangeDatePicker"
            className="form-control"
            type="text"
            placeholder={
              startDate && endDate
                ? `${format(startDate, 'MMM dd')} to ${format(
                    endDate,
                    'MMM dd'
                  )}`
                : defaultPlaceholder
            }
          />
        </Col>
      </Row>
    </div>
  );
};

export default MonthDayRange;
